import { debounce } from "lodash";

let selectedDonationValue;

function selectDonationOption(target) {
  const selectionClassName = "donation__option_selected";
  const optionsList = document.querySelector(".donation__options")
    .querySelectorAll(".donation__option");
  const numberInput = document.querySelector(".donation__input");
  const currentOption = target;
  if (!currentOption.classList.contains(selectionClassName)) {
    optionsList.forEach((option) => {
      if (option !== currentOption) {
        option.classList.remove(selectionClassName);
      }
      if (!currentOption.value && option === currentOption) {
        numberInput.classList.add("donation__input_opened");
        numberInput.attributes.required = true;
      } else {
        numberInput.classList.remove("donation__input_opened");
        numberInput.attributes.required = false;
        numberInput.value = "";
      }
    });
    currentOption.classList.add(selectionClassName);
    selectedDonationValue = currentOption.value;

  }
}

window.selectDonationOption = selectDonationOption;
if (document.querySelector("button[value='€10']")) {
  selectDonationOption(document.querySelector("button[value='€10']"));
}

function setDonationAmount(value) {
  selectedDonationValue = value;
}

window.setDonationAmount = setDonationAmount;

function getDonationAmount() {
  return selectedDonationValue;
}

window.getDonationAmount = getDonationAmount;

window.addEventListener("scroll", debounce(() => {
  const fixedDonateButton = document.querySelector(".fixed-donate-btn");
  const donateSection = document.querySelector("#donate");
  const donateButton = document.querySelector(".donation__donate-btn");
  if (isElementInViewport(donateSection) || isElementInViewport(donateButton)) {
    fixedDonateButton.classList.add("fixed-donate-btn_hidden");
  } else {
    fixedDonateButton.classList.remove("fixed-donate-btn_hidden");
  }
}, 50));
